import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import api from "../services/api.js";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";

export const createProductSchema = z.object({
  name: z.string().min(1, "O nome é obrigatório"),
  size: z.string().regex(/^\s*\d{1,4}\s*x\s*\d{1,4}\s*x\s*\d{1,4}\s*$/, {
    message: "Formato de tamanho inválido. Use: C x L x A",
  }),
  weight: z.coerce.number().positive(),
  quantity: z.coerce.number().positive(),
  ncm: z.string(),
  ii: z.coerce.number().nonnegative(),
  ipi: z.coerce.number().nonnegative(),
  pis: z.coerce.number().nonnegative(),
  cofins: z.coerce.number().nonnegative(),
  icms: z.coerce.number().nonnegative(),
});

const CreateProduct = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: zodResolver(createProductSchema) });

  const onFormSubmit = async (values) => {
    try {
      await api.post(`/products/create-product`, values);
      reset();
      setErrorMessage(null);
      navigate("/produtos");
    } catch (error) {
      setErrorMessage(
        "Não foi possível criar o produto. Verifique as informações e tente novamente"
      );
      console.error("Erro ao criar produto: ", error);
    }
  };

  return (
    <div className="bg-[#F2F2F2] rounded-md px-4 pb-4 pt-8 mt-4 text-boldGray opacity-90">
      <FormProvider {...{ register, handleSubmit, errors, reset }}>
        <form onSubmit={handleSubmit(onFormSubmit)} className="w-full mt-4 ">
          <div className="grid grid-cols-3 gap-10">
            <div>
              <label htmlFor="name" className="block mb-2 font-medium">
                Nome
              </label>
              <input
                id="name"
                placeholder="nome"
                className="w-full py-2 px-4 text-center"
                {...register("name")}
              />
            </div>

            <div>
              <label htmlFor="size" className="block mb-2 font-medium">
                Dimensões
              </label>
              <input
                id="size"
                placeholder="Dimensões"
                className="w-full py-2 px-4 text-center"
                {...register("size")}
              />
              <p className="text-red-500 text-sm">{errors.size?.message}</p>
            </div>

            <div>
              <label htmlFor="weight" className="block mb-2 font-medium">
                Peso
              </label>
              <input
                id="weight"
                placeholder="Peso"
                className="w-full py-2 px-4 text-center"
                {...register("weight")}
                type="number"
                step="0.01"
              />
            </div>

            <div>
              <label htmlFor="quantity" className="block mb-2 font-medium">
                Fardo
              </label>
              <input
                id="quantity"
                placeholder="Fardo"
                className="w-full py-2 px-4 text-center"
                {...register("quantity")}
                type="number"
              />
            </div>

            <div>
              <label htmlFor="ncm" className="block mb-2 font-medium">
                NCM
              </label>
              <input
                id="ncm"
                placeholder="NCM"
                className="w-full py-2 px-4 text-center"
                {...register("ncm")}
              />
            </div>

            <div>
              <label htmlFor="ii" className="block mb-2 font-medium">
                II
              </label>
              <input
                id="ii"
                placeholder="II"
                className="w-full py-2 px-4 text-center"
                {...register("ii")}
                type="number"
                step="0.01"
              />
            </div>

            <div>
              <label htmlFor="ipi" className="block mb-2 font-medium">
                IPI
              </label>
              <input
                id="ipi"
                placeholder="IPI"
                className="w-full py-2 px-4 text-center"
                {...register("ipi")}
                type="number"
                step="0.01"
              />
            </div>

            <div>
              <label htmlFor="pis" className="block mb-2 font-medium">
                PIS
              </label>
              <input
                id="pis"
                placeholder="PIS"
                className="w-full py-2 px-4 text-center"
                {...register("pis")}
                type="number"
                step="0.01"
              />
            </div>

            <div>
              <label htmlFor="cofins" className="block mb-2 font-medium">
                COFINS
              </label>
              <input
                id="cofins"
                placeholder="COFINS"
                className="w-full py-2 px-4 text-center"
                {...register("cofins")}
                type="number"
                step="0.01"
              />
            </div>

            <div>
              <label htmlFor="icms" className="block mb-2 font-medium">
                ICMS
              </label>
              <input
                id="icms"
                placeholder="ICMS"
                className="w-full py-2 px-4 text-center"
                {...register("icms")}
                type="number"
                step="0.01"
              />
            </div>
          </div>

          {errorMessage && (
            <div className="mt-6 bg-red-500 px-8 mx-20 rounded-md py-6 text-black">
              <p className="text-center">{errorMessage}</p>
            </div>
          )}
          <button
            className="w-full py-2 mt-10 px-4 bg-orange-500 text-white hover:bg-orange-600"
            type="submit"
          >
            CRIAR PRODUTO
          </button>
          <button
            className="w-full py-2 mt-2 px-4 bg-gray-500 text-white hover:bg-gray-600"
            type="button"
            onClick={() => navigate("/produtos")}
          >
            CANCELAR
          </button>
        </form>
      </FormProvider>
      {Object.keys(errors).length > 0 && (
        <p className="text-red-500 mt-4">
          Por favor, verifique os dados e tente novamente.
        </p>
      )}

      {/* {sucessMessage && <p className="mt-2">{sucessMessage}</p>} */}
    </div>
    // </div>
  );
};

export default CreateProduct;
